import { render, staticRenderFns } from "./OurImpact.vue?vue&type=template&id=c1b27760&scoped=true&"
var script = {}
import style0 from "./OurImpact.vue?vue&type=style&index=0&id=c1b27760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b27760",
  null
  
)

export default component.exports